<div class="background px-6 py-4 text-center text-white  dark:text-white-dark">
    © {{ currYear }}. Sourceby All rights reserved.
</div>
